import { useContext, useEffect, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import AlertDialog from "../AlertDialog/AlertDialog";
import { EDialogAction } from "../Enum/DialogActionEnum";
import JobTitlesDialogBox from "../JobTitles/JobTitlesDialogBox";
import StaffDialogBox from "./StaffDialogBox";
import { Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { LoadingStateContext } from "../../Hooks/LoadingContext/LoadingContext";
import { DeleteOutline, DeleteOutlined, EditOutlined, OpenInNew } from "@mui/icons-material";

const StaffTable = (props: { filter: any }) => {
  const [staff, setStaff] = useState(null);
  const [staffList, setStaffList] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(10);
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [alertDialogVisibility, setAlertDialogVisibility] = useState(false);
  const [dialogAction, setDialogAction] = useState(EDialogAction.view);
  const { changeLoading, isLoading } = useContext(LoadingStateContext);

  useEffect(() => {
    getStaffList();
  }, [page, props.filter, limit]);

  const getStaffList = async () => {
    changeLoading(true);
    try {
      const response = await axiosInstance.get(`/v1/staffs?page=${page}&items_per_page=${limit}`, {
        params: props.filter,
      });

      const data = response.data;
      setStaffList(data.result.data);

      setTotalItems(data.result.total);
    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false);
    }
  };

  const getStaffById = async (staffId: number, action: EDialogAction) => {
    try {
      const response = await axiosInstance.get(
        `/v1/staffs/${staffId}`,
        {}
      );

      const data = response.data;

      setStaff(data.result);

      if (action == EDialogAction.edit) {
        setEditDialogVisibility(true);
      } else if (action == EDialogAction.view) {
        setEditDialogVisibility(true);
      } else if (action == EDialogAction.delete) {
        setAlertDialogVisibility(true);
      }
      setDialogAction(action);
    } catch (err) {
      console.log(err);
    }
  };

  const goToNextPage = () => {
    setPage(page + 1);
  };

  const goToPreviousPage = () => {
    setPage(page - 1);
  };

  function editDialogClose(action: EDialogAction) {
    setEditDialogVisibility(false);
    if (action == EDialogAction.edit) {
    } else if (action == EDialogAction.view) {
    } else if (action == EDialogAction.delete) {
    }
    getStaffList();
  }
  function alertDialogClose(action: EDialogAction) {
    setAlertDialogVisibility(false);
    getStaffList();
  }

  return (
    <>
      <StaffDialogBox
        open={editDialogVisibility}
        onClose={editDialogClose}
        data={staff}
        dialogAction={dialogAction}
      />
      <AlertDialog
        openAlert={alertDialogVisibility}
        onCloseAlert={alertDialogClose}
        data={staff}
        action="staff"
      />
      <section>
        <TableContainer component={Paper}>
          <Table >
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Contact Number</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Designation</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading && <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>}

              {!isLoading && staffList.map((data: any, key: number) => {
                return (
                  <TableRow key={data.id}>
                    <TableCell>{data.id}</TableCell>
                    <TableCell>{data.name}</TableCell>
                    <TableCell>{data.contact_no}</TableCell>
                    <TableCell>{data.email}</TableCell>
                    <TableCell>{data.designation}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                          getStaffById(data.id, EDialogAction.view);
                        }}
                      >
                        <OpenInNew/>
                      </Button>{" "}
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        onClick={() => {
                          getStaffById(data.id, EDialogAction.edit);
                        }}
                      >
                        <EditOutlined/>
                      </Button>{" "}
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={() => {
                          getStaffById(data.id, EDialogAction.delete);
                        }}
                      >
                        <DeleteOutlined/>
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
              {!isLoading && staffList.length == 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No data found!
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={totalItems}
            rowsPerPage={limit}
            page={page}
            onPageChange={(event, newPage) => {
              setPage(newPage);
            }}
            onRowsPerPageChange={(event) => {
              setLimit(parseInt(event.target.value));
              setPage(0);
            }}
          />
        </TableContainer>

      </section>
    </>
  );
};

export default StaffTable;
